import { api_get, api_post } from "./api";
import { isNetworkError } from "helpers/isNetworkError";

const SENTIMENT_API_URL =
  "https://app.rapidcanvas.ai/api/v2/predict/Customer_Sentiment_Info_API";
const UNIT_SUGGESTION_URL = `${process.env.REACT_APP_RAPID_CANVAS_URL}/v2/predict/Pipa_selection_API`;
const TOKEN_URL = `${process.env.REACT_APP_URL}/crm/units/suggestion/rapidcanvas/token`;

const getRapidCanvasToken = async () => {
  try {
    const response = await api_get(TOKEN_URL);
    return response.token;
  } catch (error) {
    if (isNetworkError(error)) {
      console.error(
        "RapidCanvas token: error de red/CORS al obtener token desde",
        TOKEN_URL,
      );
      throw new Error(
        "No se pudo obtener el token de RapidCanvas (error de red/CORS). Verifica tu conexión o contacta al administrador.",
      );
    }

    if (error?.response?.status === 401 || error?.response?.status === 403) {
      console.error("RapidCanvas token: credenciales inválidas o expiradas");
      throw new Error(
        "Credenciales de RapidCanvas inválidas o expiradas. Contacta al administrador.",
      );
    }

    console.error("RapidCanvas token: error inesperado", error);
    throw new Error(
      `No se pudo obtener el token de RapidCanvas: ${error?.message || "error desconocido"}`,
    );
  }
};

export const fetchSentimentData = async (phone, idAccount) => {
  try {
    const token = await getRapidCanvasToken();
    if (!token) throw new Error("No token available");

    const formattedPhone = phone.startsWith("+52") ? phone : `+52${phone}`;
    const response = await api_post(
      SENTIMENT_API_URL,
      [{ phone: formattedPhone, id_account: idAccount }],
      { Authorization: `Bearer ${token}` }
    );
    return response[0];
  } catch (error) {
    console.error("Error fetching sentiment data:", error);
    throw error;
  }
};

export const fetchUnitSuggestions = async (requestBody) => {
  try {
    const token = await getRapidCanvasToken();
    if (!token) throw new Error("No token available");

    const response = await api_post(UNIT_SUGGESTION_URL, [requestBody], {
      Authorization: `Bearer ${token}`,
    });
    return response;
  } catch (error) {
    console.error("Error fetching unit suggestions:", error);
    throw error;
  }
};
